export function monthPeriod(month: string) {
  const match = /^(\d{4})-(\d{2})$/.exec(month);
  if (!match) return { from: "", to: "" };
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  if (monthIndex < 0 || monthIndex > 11) return { from: "", to: "" };
  return {
    from: new Date(year, monthIndex, 1).toISOString(),
    to: new Date(year, monthIndex + 1, 1).toISOString(),
  };
}
